import { ChangeEventHandler } from 'react'

import { Button } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import cl from './style.module.scss'

interface HeaderSearchProps {
	value: string
	onChange: ChangeEventHandler<HTMLInputElement>
	placeholder: string
}

export const HeaderSearchInput = (props: HeaderSearchProps) => {
	const { value, onChange, placeholder } = props

	return (
		<div className={cl.search}>
			<input className={cl.input} onChange={onChange} value={value} placeholder={placeholder} />
			<Button id="js-digi-search-button" theme={'clear'} className={cl.button}>
				<Icon name={'Search'} />
			</Button>
		</div>
	)
}
